export default "__VITE_ASSET__oyT$yglJ__"